import { Endpoint } from "shared/utils/endpoints";
import { SCHOOL_HTTP_CLIENT } from "shared/utils/schoolInterceptor";

/**
 * A school's plan and payment history — the same two routes the school panel's
 * Membership Plans screen calls (`getPlanHistory` / `getPaymentHistory` in
 * aliflailaweb's `membershipService`), pointed at a school by id.
 *
 * Both are paginated server-side and answer
 * `data.plans.{data,pagination}` / `data.transactions.{data,pagination}`.
 */

/** Both histories are paginated server-side: `pagination.{total,last_page}`. */
interface HistoryParams {
  page?: number;
  per_page?: number;
}

/** Every plan the school has held, newest first. */
const getPlanHistory = (id: number | string, params?: HistoryParams) =>
  SCHOOL_HTTP_CLIENT.get(`${Endpoint.school_membership.plansHistory}/${id}`, {
    params,
  });

/** Every payment recorded against those plans, with instalment numbering. */
const getPaymentHistory = (id: number | string, params?: HistoryParams) =>
  SCHOOL_HTTP_CLIENT.get(`${Endpoint.school_membership.paymentHistory}/${id}`, {
    params,
  });

/**
 * The instalment schedule of one plan — the route the school panel's
 * Installment Details table calls. Admin has to name the school with
 * `user_id`; a plan that belongs to another school answers "No installments
 * found for the plan."
 */
const getPlanInstallments = (planId: number | string, schoolId: number | string) =>
  SCHOOL_HTTP_CLIENT.get(`${Endpoint.school_membership.installments}/${planId}`, {
    params: { user_id: schoolId },
  });

export { getPlanHistory, getPaymentHistory, getPlanInstallments };
